export const BuildInfo = {timestamp:1779838704000}
